import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ComputeProductsPage from "@/pages/products/ComputeProductsPage";

export const Route = createFileRoute("/products/compute")({
  head: () => pageHead("AI Compute & GPU Infrastructure", "High-performance AI workstations, GPU servers, and HPC clusters for training and inference. Run open-weight models locally on the latest NVIDIA and AMD hardware.", "/products/compute", false),
  component: ComputeProductsPage,
});
